import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.farm.cage');
import { OnInit, Input, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import moment from 'moment';

@Component({
    selector: 'wiz-portal-farm-cage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.farm.cage/view.scss */
/* src/app/portal.farm.cage/view.scss: no such file or directory */`],
})
export class PortalFarmCageComponent implements OnInit {

    @ViewChild('modalMessage') modalMessage: any;

    @Input() farm_id!: string;
    @Input() farm!: any;

    constructor(@Inject( Service) public service: Service) {}

    public modal = {
        supply: false,
        env: false,
        cagein: false,
        cageout: false
    };

    public modalData: any = null;

    public info = {
        list: [] as any[],
        data: {} as any,
        search: {
            start: moment().subtract(14, 'days').format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        }
    };

    public supply = { list: [] as any[] };
    public env = { list: [] as any[] };
    public cagein = { list: [] as any[] };
    public cageout = { list: [] as any[] };


    async ngOnInit() {
        await this.service.init();
        await this.loadInfo();
        await this.service.render();
    }

    private async showModal(message: string): Promise<void> {
	    await this.modalMessage.open({ message });
	}

    private async loadInfo() {
        const res = await wiz.call("cages", { farm_id: this.farm_id });
        this.info.list = res?.data || [];

        if (this.info.list.length === 0) {
            this.createInfo();
        } else if (!this.info.data?.id) {
            await this.selectInfo(this.info.list[0]);
        }

        await this.service.render();
    }

    public async selectInfo(item: any) {
        this.removeUnsavedNewCage();
        this.info.data = item;
        await this.loadChildren();
        await this.service.render();
    }

    public async createInfo() {
        this.removeUnsavedNewCage();

        const newCage: any = {
            id: undefined,
            cage_name: '새로운 계사',
            cage_num: null,
            cage_model: 'A형케이지',
            feed_type: '체인식',
            collect_type: '자동집란',
            milling_type: '배사겸용 제분기',
            ave_weight: '',
            density: '',
            _isNew: true
        };

        this.info.list.push(newCage);
        this.info.data = newCage;

        await this.service.render(); 
    }

    private removeUnsavedNewCage() {
        this.info.list = this.info.list.filter((item: any) => !item._isNew);
    }

    public async updateInfo() {
        const name = (this.info.data.cage_name || '').trim();
        const num = this.info.data.cage_num;

        if (!name || num === null || num === undefined || String(num).trim() === '') {
            this.showModal("계사이름과 계사번호는 필수값입니다.");
            return;
        }

        const data = { ...this.info.data, farm_id: this.farm_id };
        delete data._isNew;

        const res = await wiz.call("update", data);
        
        if (res.code !== 200) {

            const message =
                res?.data ||
                res?.message ||
                "이미 존재하는 계사번호입니다.";

            await this.showModal(message);
            return;
        }

        this.showModal("저장되었습니다.");

        await this.loadInfo();

        const savedId = res.data;
        const selected = this.info.list.find((x: any) => x.id === savedId);

        if (selected) {
            await this.selectInfo(selected);
        }

        await this.service.render();
    }

    private buildSearch() {
        return {
            start: moment(this.info.search.start).format('YYYY-MM-DD'),
            end: moment(this.info.search.end).format('YYYY-MM-DD'),
            cage_id: this.info.data.id
        };
    }

    public async loadChildren() {
        if (!this.info.data?.id) return;

        await Promise.all([
            this.loadSupply(),
            this.loadEnv(),
            this.loadCageIn(),
            this.loadCageOut()
        ]);
    }

    private async loadSupply() {
        const res = await wiz.call("supply", this.buildSearch());
        this.supply.list = res?.data || [];
        await this.service.render();
    }

    public addSupply() { this.openModal('supply'); }

    public editSupply(item: any) {
        this.openModal('supply', {
            ...item,
            date: new Date(item.date)
        });
    }

    public async handleSupply(result: any) {
        await this.closeModal('supply');
        if (!result) return;

        await wiz.call("update_supply", {
            ...result,
            farm_id: this.farm_id,
            cage_id: this.info.data.id
        });

        await this.loadSupply();
    }

    public async removeSupply(item: any) {
        await wiz.call("remove_supply", item);
        await this.loadSupply();
    }

    private async loadEnv() {
        const res = await wiz.call("env", this.buildSearch());
        this.env.list = res?.data || [];
        await this.service.render();
    }

    public addEnv() { this.openModal('env'); }

    public editEnv(item: any) {
        this.openModal('env', {
            ...item,
            date: new Date(item.date)
        });
    }

    public async handleEnv(result: any) {
        await this.closeModal('env');
        if (!result) return;

        await wiz.call("update_env", {
            ...result,
            farm_id: this.farm_id,
            cage_id: this.info.data.id
        });

        await this.loadEnv();
    }

    public async removeEnv(item: any) {
        await wiz.call("remove_env", item);
        await this.loadEnv();
    }

    private async loadCageIn() {
        const res = await wiz.call("cagein", this.buildSearch());
        this.cagein.list = res?.data || [];
        await this.service.render();
    }

    public addCageIn() { this.openModal('cagein'); }

    public editCageIn(item: any) {
        this.openModal('cagein', {
            ...item,
            date: new Date(item.date),
            in_date: new Date(item.in_date),
            pre_date: new Date(item.pre_date),
            pre_in_date: new Date(item.pre_in_date)
        });
    }

    public async handleCageIn(result: any) {
        await this.closeModal('cagein');
        if (!result) return;

        await wiz.call("update_cagein", {
            ...result,
            farm_id: this.farm_id,
            cage_id: this.info.data.id
        });

        await this.loadCageIn();
    }

    public async removeCageIn(item: any) {
        await wiz.call("remove_cagein", item);
        await this.loadCageIn();
    }

    private async loadCageOut() {
        const res = await wiz.call("cageout", this.buildSearch());
        this.cageout.list = res?.data || [];
        await this.service.render();
    }

    public addCageOut() { this.openModal('cageout'); }

    public editCageOut(item: any) {
        this.openModal('cageout', {
            ...item,
            date: new Date(item.date)
        });
    }

    public async handleCageOut(result: any) {
        await this.closeModal('cageout');
        if (!result) return;

        await wiz.call("update_cageout", {
            ...result,
            farm_id: this.farm_id,
            cage_id: this.info.data.id
        });

        await this.loadCageOut();
    }

    public async removeCageOut(item: any) {
        await wiz.call("remove_cageout", item);
        await this.loadCageOut();
    }

    public async openModal(type: keyof typeof this.modal, data: any = null) {
        this.modalData = data;
        this.modal[type] = true;
        await this.service.render();
    }

    public async closeModal(type: keyof typeof this.modal) {
        this.modal[type] = false;
        this.modalData = null;
        await this.service.render();
    }

}

export default PortalFarmCageComponent;